import React from 'react'

import {
  AlignItems,
  Body3,
  Box,
  Color,
  Display,
  FontFamily,
  Icon,
  IconVariant,
  Image,
  Link,
  Space,
  Text,
} from '@gousto-internal/citrus-react'
import { useDispatch, useSelector } from 'react-redux'

import { boxSummaryVisibilityChange } from 'actions/boxSummary'
import { useBasket } from 'routes/Menu/domains/basket'
import { useCollections } from 'routes/Menu/domains/collections'
import { getCuratedBoxCollectionId } from 'routes/Menu/selectors/menu'

import { SwapSvg } from './SwapSvg'

type RecipeLineProps = {
  onDetailsClick: () => void
  recipeImageSrc: string
  quantity: number
  recipeId: string
  title: string
}
export const RecipeLine = ({
  onDetailsClick,
  recipeImageSrc,
  quantity,
  recipeId,
  title,
}: RecipeLineProps) => {
  const dispatch = useDispatch()

  const { removeRecipe } = useBasket()
  const { changeCollectionById } = useCollections()
  const curatedBoxCollectionId = useSelector(getCuratedBoxCollectionId)

  const swapRecipe = () => {
    removeRecipe(recipeId, 'swap')
    dispatch(boxSummaryVisibilityChange(false, removeRecipe))
    changeCollectionById(curatedBoxCollectionId)
  }

  return (
    <Box
      width="310px"
      display={Display.Flex}
      data-testid={`recipeLine${recipeId}`}
      paddingBottom={2}
    >
      <Box data-testId={`recipeLineImageContainer${recipeId}`} onClick={() => onDetailsClick()}>
        <Image width="120px" height="120px" fit="cover" src={recipeImageSrc} alt="" />
      </Box>
      <Box display={Display.Flex} alignItems={AlignItems.Center} paddingH={2}>
        <Box>
          {/* this is an erroneous warning as Link without href renders a button */}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            size={2}
            onClick={() => {
              onDetailsClick()
            }}
            style={{ boxShadow: 'none' }}
          >
            <Text color={Color.ColdGrey_800} fontFamily={FontFamily.Bold} size={1}>
              {title} &gt;
            </Text>
          </Link>
          <Space size={1} />
          <Body3>{quantity} servings</Body3>
          <Space size={1} />
          <Box display={Display.Flex}>
            <Box display={Display.Flex} alignItems={AlignItems.Center}>
              <SwapSvg />
              <Space size={1} direction="horizontal" />
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link
                size={2}
                onClick={() => {
                  swapRecipe()
                }}
              >
                Swap
              </Link>
            </Box>
            <Space size={2} direction="horizontal" />
            <Box display={Display.Flex} alignItems={AlignItems.Center}>
              <Icon name="clear" variant={IconVariant.Actionable} />
              <Space size={1} direction="horizontal" />
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link
                size={2}
                onClick={() => {
                  removeRecipe(recipeId, 'boxSummaryMinus')
                }}
              >
                Remove
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
